import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ActivityIcon, DropletIcon, UtensilsIcon, UserIcon } from 'lucide-react';
const problems = [{
  icon: DropletIcon,
  trigger: 'Territory invasion',
  result: 'Bladder infection'
}, {
  icon: UtensilsIcon,
  trigger: 'Indigestible situation',
  result: 'Digestive flare-up'
}, {
  icon: UserIcon,
  trigger: 'Attack on identity',
  result: 'Skin breakout'
}];
export function TheProblem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-20 px-6 md:px-12" data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto space-y-12" data-id="element-107">
        <div className="space-y-6" data-id="element-108">
          <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-109">
            What if your body isn't "broken"?
          </h2>
          <p className="text-lg md:text-xl text-stone-300 leading-relaxed max-w-4xl mx-auto" data-id="element-110">
            What if that physical pain is actually the only way your
            subconscious knows how to speak to you? When you experience a stress
            or a trauma that is too heavy for your mind to process, your brain
            "downloads" that conflict into a specific organ.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-111">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-dark-navy-light border-l-4 border-teal-accent p-6 rounded-lg space-y-4 hover:cyan-glow transition-shadow" data-id="element-112">
              <problem.icon className="w-10 h-10 text-teal-accent" data-id="element-113" />
              <div className="space-y-2" data-id="element-114">
                <p className="text-stone-400 text-sm uppercase tracking-wide" data-id="element-115">
                  Emotional Trigger
                </p>
                <p className="text-white font-semibold text-lg" data-id="element-116">
                  "{problem.trigger}"
                </p>
                <div className="flex items-center gap-2 text-teal-accent" data-id="element-117">
                  <span className="text-2xl" data-id="element-118">→</span>
                  <p className="font-medium" data-id="element-119">{problem.result}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <p className="text-lg md:text-xl text-stone-300 leading-relaxed max-w-4xl mx-auto text-center" data-id="element-120">
          As long as the emotional conflict remains "active" in your mind, your
          body will keep producing the symptom to protect you. This is why the
          pills only work temporarily—they are silencing the messenger without
          reading the message.
        </p>
      </motion.div>
    </section>;
}